import cx from 'classnames';
import { useResourceBundle } from '../contexts/ResourceContext';
import { useAppSelector } from '../hooks/useRedux';

const CallYou = ({ classNames = ['u-Space-up--lg', 'u-Space-down'] }: { classNames?: string[] }) => {
  const selectedArea = useAppSelector((state) => state.navigation.area);
  const isClaim = useAppSelector((state) => state.navigation.category === 'injury');
  const resource = useResourceBundle();

  let resourceKey = 'label.call.notice';
  if (selectedArea === 'commercial' || selectedArea === 'agriculture') {
    resourceKey = isClaim ? 'label.call.claims.notice' : 'label.commercial.call.notice';
  } else if (selectedArea === 'private') {
    resourceKey = 'label.call.claims.notice';
  }

  return <div className={cx(classNames)}>{resource[resourceKey]}</div>;
};

export default CallYou;
